/* @flow */

export {InfoPopover} from './info-popover';
